import React from "react";

export const PhoneIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M2.94 4.04a1.5 1.5 0 0 1 1.62-.33l2.38 1a1.5 1.5 0 0 1 .9 1.17l.3 2.1a10.07 10.07 0 0 0 4.18 4.18l2.1.3a1.5 1.5 0 0 1 1.17.9l1 2.38a1.5 1.5 0 0 1-.33 1.62l-1.06 1.06a2 2 0 0 1-1.91.52A15.48 15.48 0 0 1 2.56 8.11a2 2 0 0 1 .52-1.91l1.06-1.06-.2-.1.2.1Z" />
  </svg>
);
